import {
  GET_REVENUE_CENTERS_REQUESTED,
  GET_REVENUE_CENTERS_SUCCEEDED,
  GET_REVENUE_CENTERS_FAILED,
} from './constants'
import DataMapper from '../../utils/dataMapper'

export const defaultState = {}

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case GET_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case GET_REVENUE_CENTERS_SUCCEEDED:
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        byId,
        isLoading: false,
      }

    case GET_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: false }

    default:
      return state
  }
}
